import { useDropdownGroup } from '@anm/components/Dropdown';
import CATEGORIES from '@anm/data/video-templates/header-categories';
import { memo, FC } from 'react';

import ListItem from './ListItem';
import ListWrapper from './Wrapper';
import { CategoryListProps } from './types';

const CategoryList: FC<CategoryListProps> = ({ color }) => {
  const [delay, handleDropdownOpen, handleDropdownClose] = useDropdownGroup();

  return (
    <ListWrapper>
      {CATEGORIES.map(props => (
        <ListItem
          key={props.page}
          {...{
            ...props,
            color,
            delay,
            handleDropdownOpen,
            handleDropdownClose
          }}
        />
      ))}
    </ListWrapper>
  );
};

export default memo(CategoryList);
